"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["waitingMessage", "models", "model", "onChange"];
var _VehicleModelSelect_models;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { graphql } from 'react-relay';
import { useFragment } from 'react-relay/hooks';
import { VehicleSelectInput } from '../VehicleSelectInput/VehicleSelectInput';
import { jsx as _jsx } from "react/jsx-runtime";
export const VehicleModelSelect = _ref => {
  let {
      waitingMessage,
      models: modelsRef,
      model,
      onChange = () => void 0
    } = _ref,
    inputProps = _objectWithoutProperties(_ref, _excluded);
  const models = useFragment(_VehicleModelSelect_models !== void 0 ? _VehicleModelSelect_models : _VehicleModelSelect_models = require("../../../relay/__generated__/VehicleModelSelect_models.graphql"), modelsRef);
  return /*#__PURE__*/_jsx(VehicleSelectInput, _objectSpread(_objectSpread({}, inputProps), {}, {
    waitingMessage: waitingMessage,
    isLoading: !models,
    vehicleData: models ? models : [],
    value: model,
    name: "Model",
    placeholder: "Which model?",
    popularOptionsGroupTitle: "Popular Models",
    nonePopularOptionsGroupTitle: "Other Models",
    onChange: onChange
  }));
};
export default VehicleModelSelect;